import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=b42b99c2&scoped=true"
import script from "./NoResults.vue?vue&type=script&lang=js"
export * from "./NoResults.vue?vue&type=script&lang=js"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=b42b99c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42b99c2",
  null
  
)

export default component.exports